// extracted by mini-css-extract-plugin
export default {"card":"ShowMore_card__cb7bP","innerBox":"ShowMore_innerBox__OkveT","place":"ShowMore_place__ZmpPQ","arrow":"ShowMore_arrow__bXCxZ"};